import PreviewsItem from "./previews-item";

const PreviewsList = ({
  image,
  previews,
  previewsSelected,
  activeCategory,
  uploadElement,
  imageName,
  width,
  height,
  previewPosition,
  previewCategory,
  selectPreview,
  showDescription,
  dispatch,
  imageDownload,
  showPreviewEditPopup,
  analytics,
  service
}) => {
  const categories = Object.keys(previews);

  const block = categories.map((category, categoryKey) => {
    const previewsBlocks = previews[category].map((preview, previewKey) => {
      return (
        <PreviewsItem
          previewKey={previewKey}
          image={image}
          imageWidth={width}
          imageHeight={height}
          imageName={imageName}
          previewItem={preview}
          previewPosition={previewPosition}
          previewCategory={previewCategory}
          previewSelected={previewsSelected}

          isCategoryShow={activeCategory === category}
          uploadElement={uploadElement}
          selectPreview={selectPreview}
          showPreviewEditPopup={showPreviewEditPopup}
          imageDownload={imageDownload}
          showDescription={showDescription}
          key={previewKey}
          dispatch={dispatch}
          analytics={analytics}
          service={service}
        />
      );
    });

    return (
      <ul key={categoryKey}
        className={`preview__items ${activeCategory === category ? 'preview__items_active' : ''}`}>
        {previewsBlocks}
      </ul>
    );
  });

  return <>{block}</>;
};

export default PreviewsList;
